import api from "../api/axios";
import {
  CreateTournamentInput,
  DeleteTournamentResponse,
  PaginatedTournamentsResponse,
  UpdateTournamentResponse,
  TournamentStatus,
  Tournament,
} from "./tournament.types";

export const createTournament = async (
  payload: CreateTournamentInput,
): Promise<Tournament> => {
  try {
    const response = await api.post(`/tournaments/create`, payload);
    return response.data.tournament;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.error ||
        error.message ||
        "Error creating tournament",
    );
  }
};

export const deleteTournament = async (
  tournamentId: string,
): Promise<DeleteTournamentResponse> => {
  try {
    const response = await api.delete(`/tournaments/${tournamentId}`);
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.error ||
        error.message ||
        "Error deleting tournament",
    );
  }
};

export const fetchAllTournaments = async (
  page: number = 1,
  limit: number = 10,
  status?: TournamentStatus,
  userCountry?: string,
): Promise<PaginatedTournamentsResponse> => {
  try {
    const params: any = { page, limit };
    if (status) params.status = status;
    if (userCountry) params.userCountry = userCountry;
    const response = await api.get(`/tournaments/all`, { params });
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.error ||
        error.message ||
        "Error fetching tournaments",
    );
  }
};

export const fetchUserHostedTournaments = async (
  page: number = 1,
  limit: number = 10,
  userCountry?: string,
): Promise<PaginatedTournamentsResponse> => {
  try {
    const params: any = { page, limit };
    if (userCountry) params.userCountry = userCountry;
    const response = await api.get(`/tournaments/my-tournaments`, {
      params,
    });
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.error ||
        error.message ||
        "Error fetching user tournaments",
    );
  }
};

export const fetchUserJoinedTournaments = async (
  page: number = 1,
  limit: number = 10,
  userCountry?: string,
): Promise<PaginatedTournamentsResponse> => {
  try {
    const params: any = { page, limit };
    if (userCountry) params.userCountry = userCountry;
    const response = await api.get(`/tournaments/joined-tournaments`, {
      params,
    });
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.error ||
        error.message ||
        "Error fetching joined tournaments",
    );
  }
};

export const fetchTournamentById = async (
  tournamentIdOrUrl: string,
  userCountry?: string,
): Promise<Tournament> => {
  try {
    const params: any = {};
    if (userCountry) params.userCountry = userCountry;
    const response = await api.get(`/tournaments/${tournamentIdOrUrl}`, { params });
    return response.data.tournament;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.error ||
        error.message ||
        "Error fetching tournament",
    );
  }
};

export const updateTournament = async (
  tournamentId: string,
  updateData: Partial<CreateTournamentInput>,
): Promise<UpdateTournamentResponse> => {
  try {
    const response = await api.put(
      `/tournaments/update/${tournamentId}`,
      updateData,
    );
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.error ||
        error.message ||
        "Error updating tournament",
    );
  }
};

export const joinTournament = async (
  tournamentId: string,
  paymentRef: string,
  amount: number | string,
  currency: string,
): Promise<Tournament> => {
  try {
    const response = await api.post(`/tournaments/join/${tournamentId}`, {
      paymentRef,
      amount,
      currency,
    });
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.error ||
        error.message ||
        "Error joining tournament",
    );
  }
};

export const joinFreeTournament = async (
  tournamentId: string,
  amount: number | string,
  currency: string,
): Promise<Tournament> => {
  try {
    const response = await api.post(`/tournaments/join-free/${tournamentId}`, {
      amount,
      currency,
    });
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.error ||
        error.message ||
        "Error joining tournament",
    );
  }
};


export const startTournament = async (
  tournamentId: string,
): Promise<Tournament> => {
  try {
    const response = await api.post(`/tournaments/start/${tournamentId}`);
    return response.data.tournament;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.error ||
        error.message ||
        "Error starting tournament",
    );
  }
};
